module.exports = __webpack_public_path__ + "img/wein-nachhaltigkeit-mobil.c9d30cd8.jpg";